import React from 'react';
import {connect} from 'react-redux';
import {injectIntl, intlShape} from 'react-intl';
import {setProjectId} from '../reducers/project-id';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

// import analytics from './analytics';
import log from './log';
import storage from './storage';
import {setTitle, setUrl, setClassId, setClassName, setCourseId, setUnitId, setLessonId} from '../reducers/homework';
import {getParameterByName, removeUrlProtocal} from '../utils/tools'
import {getLatestWorkData, getParticularHomeworkData} from './service';
import {getHomeworkInfo, setHomeworkInfo} from './homework-info';
import JSZip from 'jszip';

let storeProjectUrl = '';

/* Higher Order Component to provide behavior for loading projects by id. If
 * there's no id, the default project is loaded.
 * @param {React.Component} WrappedComponent component to receive projectData prop
 * @returns {React.Component} component with project loading behavior
 */
const ProjectLoaderHOC = function (WrappedComponent) {
    class ProjectLoaderComponent extends React.Component {
        constructor (props) {
            super(props);
            this.handleHashChange = this.handleHashChange.bind(this);
            this.updateProject = this.updateProject.bind(this);
            this.loadProject = this.loadProject.bind(this);
            this.latestWorkUrl = null;
            this.homeworkUrl = null;
            this.state = {
                projectData: null,
                fetchingProject: false
            };
            storage.setProjectHost(props.projectHost);
            storage.setAssetHost(props.assetHost);
            storage.setTranslatorFunction(props.intl.formatMessage);
            props.setProjectId(props.projectId);
            // if (
            //     props.projectId !== '' &&
            //     props.projectId !== null &&
            //     typeof props.projectId !== 'undefined'
            // ) {
            //     this.updateProject(props.projectId);
            // }
        }

        componentDidMount () {
            window.addEventListener('hashchange', this.handleHashChange);
            this.handleHashChange();
        }
        componentWillUpdate (nextProps) {
            if (this.props.projectHost !== nextProps.projectHost) {
                storage.setProjectHost(nextProps.projectHost);
            }
            if (this.props.assetHost !== nextProps.assetHost) {
                storage.setAssetHost(nextProps.assetHost);
            }

            // 判断是否为null，才更新state 否则现有核桃的加载作业之类的会先加载默认项目再加载作业，有刷新两次的bug
            if (this.props.projectId !== null &&
                this.props.projectId !== nextProps.projectId) {
                this.props.setProjectId(nextProps.projectId);
                this.setState({fetchingProject: true}, () => {
                    this.updateProject(nextProps.projectId);
                });
            }
        }
        componentWillUnmount () {
            window.removeEventListener('hashchange', this.handleHashChange);
        }

        handleHashChange () {
            const sb3Url = getParameterByName('sb3Url');
            let projectJSONUrl = getParameterByName('projectJSONUrl');
            const snapshotURL = getParameterByName('snapshotUrl');
            if (sb3Url && (projectJSONUrl || snapshotURL)) {
                this.setState({
                    fetchingProject: true
                });
                const opts = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/octet-stream'
                    }
                };
                let fetchingPromise = null;
                if (snapshotURL) {
                    fetchingPromise = Promise.all([fetch(sb3Url, opts), fetch(snapshotURL)]).then(([sb3Res, snapshotRes]) => {
                        return snapshotRes.blob().then((snapshotBlob) => {
                            return [sb3Res, snapshotBlob]
                        })
                    })
                } else {
                    fetchingPromise =  Promise.all([fetch(sb3Url, opts), fetch(projectJSONUrl)])
                }
                fetchingPromise
                    .then(([sb3Res, snapshotZipBlobOrJsonRes]) => {
                        if (snapshotURL) {
                            return JSZip.loadAsync(snapshotZipBlobOrJsonRes)
                                .then((zip) => {
                                    return zip.file("project.json").async("blob")
                                })
                                .then((projectJSONBlob) => {
                                    return [sb3Res, projectJSONBlob]
                                })
                        }
                        return [sb3Res, snapshotZipBlobOrJsonRes]
                    })
                    .then(([sb3Res, projectJSONRes]) => Promise.all([sb3Res.blob(), projectJSONRes.text()]))
                    .then(([blob, projectJSON]) => {
                        return JSZip.loadAsync(blob)
                            .then((zip) => {
                                zip.file("project.json", projectJSON);
                                return zip.generateAsync({type: "blob"});
                            })
                            .then(blob => {
                                this.setState({
                                    projectData: blob,
                                    fetchingProject: false
                                });
                            })
                    })
                    .catch(error => {
                        sa.track('s3_fetch_project_error', {
                            project_url: projectUrl,
                            error: error.message
                        });
                        log.error(error);
                        // eslint-disable-next-line no-alert
                        alert('请求文件过程中出现了错误，请检查网络连接是否正常~' + error.message);
                    });
                return;
            }
            const self = this;
            const homeworkInfo = getHomeworkInfo();
            const userId = homeworkInfo.userId === '' ? Number(Cookies.get('userId')) : Number(homeworkInfo.userId);
            let projectUrl = homeworkInfo.projectUrl;
            this.props.onUrlUpdate(homeworkInfo.projectUrl);
            this.props.onTitleUpdate(homeworkInfo.title);
            this.props.onClassNameUpdate(homeworkInfo.className);
            this.props.onCourseIdUpdate(Number(homeworkInfo.courseId));
            this.props.onClassIdUpdate(Number(homeworkInfo.classId));
            this.props.onUnitIdUpdate(Number(homeworkInfo.unitId));
            this.props.onLessonIdUpdate(Number(homeworkInfo.lessonId));

            const goAheadWithUrl = () => {
                if (this.props.projectUrl) {
                    projectUrl = this.props.projectUrl;
                }
                if (this.latestWorkUrl !== null) {
                    projectUrl = this.latestWorkUrl;
                }
                if (this.homeworkUrl !== null) {
                    projectUrl = this.homeworkUrl;
                }
                projectUrl = removeUrlProtocal(projectUrl);
                if (projectUrl !== '' && storeProjectUrl !== projectUrl) {
                    this.loadProject(projectUrl);
                    storeProjectUrl = projectUrl;
                    return;
                }
                this.updateProject(0);
            };

            // 取特定的作业文件
            if (homeworkInfo.homeworkId !== '') {
                log.info('加载作业');
                this.setState({
                    fetchingProject: true
                });
                getParticularHomeworkData(homeworkInfo.homeworkId).then(res => {
                    if (res.errcode === 0) {
                        const data = res.data;
                        const newHomeworkInfo = {
                            userId: data.user.id,
                            projectUrl: data.url,
                            unitId: data.unitId,
                            courseId: data.courseId,
                            lessonId: data.lessonId,
                            classId: data.classId,
                            sectionId: data.sectionId,
                            title: data.title,
                            projectAnswerUrl: data.lesson && data.lesson.answer
                        };
                        this.homeworkUrl = data.url;
                        self.props.onTitleUpdate(data.title);
                        setHomeworkInfo(newHomeworkInfo);
                    }
                })
                    .catch(err => {
                        log.info('加载作业失败');
                        log.info(err);
                    })
                    .finally(goAheadWithUrl);
                return;
            }

            // 已经登录且courseId lessonId 不为空时请求最近一次的作品
            if (userId > 0 && homeworkInfo.courseId !== '' && homeworkInfo.lessonId !== '') {
                log.info('加载最近一次作品');
                this.setState({
                    fetchingProject: true
                });
                getLatestWorkData(userId, homeworkInfo.courseId, homeworkInfo.lessonId)
                    .then(data => {
                        self.latestWorkUrl = data.latestWorkUrl;
                        const projectAnswerUrl = {
                            projectAnswerUrl: data.projectAnswerUrl
                        };
                        setHomeworkInfo(projectAnswerUrl);
                    })
                    .catch(error => {
                        log.info('加载最近一次作品失败');
                        log.error(error);
                    })
                    .finally(goAheadWithUrl);
                return;
            }

            goAheadWithUrl();
        }

        loadProject (projectUrl) {
            const self = this;
            const opts = {
                method: 'GET',
                headers: {
                    Accept: 'application/octet-stream'
                }
            };
            fetch(projectUrl, opts)
                .then(response => response.blob())
                .then(blob => {
                    self.setState({
                        projectData: blob,
                        fetchingProject: false
                    });
                })
                .catch(error => {
                    sa.track('s3_fetch_project_error', {
                        project_url: projectUrl,
                        error: error.message
                    });
                    log.error(error);
                    // eslint-disable-next-line no-alert
                    alert('请求文件过程中出现了错误，请检查网络连接是否正常~' + error.message);
                });
        }

        updateProject (projectId) {
            storage
                .load(storage.AssetType.Project, projectId, storage.DataFormat.JSON)
                .then(projectAsset => projectAsset && this.setState({
                    projectData: projectAsset.data,
                    fetchingProject: false
                }))
                .then(() => {
                    // if (projectId !== 0) {
                    //     analytics.event({
                    //         category: 'project',
                    //         action: 'Load Project',
                    //         label: projectId,
                    //         nonInteraction: true
                    //     });
                    // }
                })
                .catch(err => log.error(err));
        }

        render () {
            const {
                /* eslint-disable no-unused-vars */
                assetHost,
                projectHost,
                projectId,
                setProjectId: setProjectIdProp,
                /* eslint-enable no-unused-vars */
                ...componentProps
            } = this.props;
            if (!this.state.projectData) return null;
            return (
                <WrappedComponent
                    fetchingProject={this.state.fetchingProject}
                    projectData={this.state.projectData}
                    {...componentProps}
                />
            );
        }
    }

    ProjectLoaderComponent.propTypes = {
        assetHost: PropTypes.string,
        intl: intlShape.isRequired,
        onClassIdUpdate: PropTypes.func,
        onClassNameUpdate: PropTypes.func,
        onCourseIdUpdate: PropTypes.func,
        onLessonIdUpdate: PropTypes.func,
        onTitleUpdate: PropTypes.func,
        onUnitIdUpdate: PropTypes.func,
        onUrlUpdate: PropTypes.func,
        projectHost: PropTypes.string,
        projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        setProjectId: PropTypes.func
    };

    ProjectLoaderComponent.defaultProps = {
        assetHost: 'https://cdn.assets.hetao101.com',
        projectHost: 'https://cdn.assets.hetao101.com',
        projectId: 0
    };

    const mapDispatchToProps = dispatch => ({
        onUrlUpdate: url => dispatch(setUrl(url)),
        onTitleUpdate: title => dispatch(setTitle(title)),
        onCourseIdUpdate: id => dispatch(setCourseId(id)),
        onClassIdUpdate: id => dispatch(setClassId(id)),
        onClassNameUpdate: name => dispatch(setClassName(name)),
        onUnitIdUpdate: id => dispatch(setUnitId(id)),
        onLessonIdUpdate: id => dispatch(setLessonId(id)),
        setProjectId: id => dispatch(setProjectId(id))
    });

    const mapStateToProps = () => ({});

    return injectIntl(connect(
        mapStateToProps,
        mapDispatchToProps
    )(ProjectLoaderComponent));
};

export {
    ProjectLoaderHOC as default
};
